import { createUseStyles } from 'react-jss';
import { ITheme } from '../theme';

export const mainBoxStyles = { flexGrow: 1 };
export const childBoxStyles = { display: { xs: 'none', md: 'flex' }, justifyContent: 'flex-end' };

type RuleNames =
  | 'mainBox'
  | 'inviteBtn'
  | 'blockHeader'
  | 'menu'
  | 'search'
  | 'emailIcon'
  | 'accountIcon'
  | 'headerIcon';

const PREFIX = 'Header';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      mainBox: {
        '& .MuiToolbar-root': {
          width: '1160px',
          height: '64px',
          margin: '0 auto',
          padding: '0px',
        },
        '& .MuiPaper-root': {
          background: theme.darkGrey,
        },
        '& .MuiTypography-root': {
          fontSize: '24px',
          fontWeight: 400,
        },
      },
      headerIcon: {
        marginTop: '10px',
      },
      search: {
        marginLeft: '0px',
      },
      inviteBtn: {
        backgroundColor: theme.black,
      },
      blockHeader: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        cursor: 'pointer',
      },
      menu: {
        marginLeft: -37,
        '& .MuiMenu-list': {
          width: 85,
          padding: 0,
        },
      },
      emailIcon: {
        '& .MuiSvgIcon-root': {
          width: '1.2em',
          height: '1.2em',
        },
      },
      accountIcon: {
        '& .MuiSvgIcon-root': {
          width: '1.1em',
          height: '1.1em',
        },
      },
    }
  ),
  { name: PREFIX },
);
